import { atom } from "recoil"

export const teamMemberContactsRequestIdState = atom({
  key: "atoms/contact/teamMemberContactsRequestIdState",
  default: 0,
})
